export default __webpack_public_path__ + "static/media/TCSBANNERPOP.bc57d22d.png";